import { gql } from '@apollo/client/core';

export const GET_TEAM_BY_TOURNAMENT = gql`
    query GetTeams($documentId: ID!, $page: Int!, $pageSize: Int!, $keyword: String!) {
        teams_connection(
            filters: {
                tournament: {
                    documentId: {
                        eq: $documentId
                    }
                },
                name: {
                    contains: $keyword
                }
            },
            pagination: { page: $page, pageSize: $pageSize },
            sort: ["createdAt:desc"]
        ) {
            nodes {
                documentId
                name
                players {
                    display_name
                    email
                    first_name
                    last_name
                    middle_name
                    birthday
                    phone
                    address
                    id_no
                    id_verified
                    note
                    total_point
                    position
                    play_handed
                    photo {
                        documentId
                        name
                        url
                    }
                }
            }
            pageInfo {
                page
                pageCount
                pageSize
                total
            }
        }
    }
`;